import loaderMixin from '@/mixins/loader';
import accountVerifyMixin from '@/mixins/accountVerify';
import { mapActions, mapState } from 'vuex';
import { MODALS } from '@/components/app/app-modals/app-modals';

export default {
  mixins: [
    accountVerifyMixin,
    loaderMixin,
  ],
  computed: {
    ...mapState('profile', ['userAffiliations', 'isUCAffilSet']),
  },
  methods: {
    ...mapActions('profile', ['getUserAffiliations']),
    ...mapActions('popup', [
      'setCurrentSmallPopup', 'setCurrentPopup', 'setCurrentPopupOptions',
    ]),
    showAffiliationsPopup() {
      if (!this.hasUserClassicEnabled) {
        this.setCurrentPopup(MODALS.ACCOUNT_ENABLE_CLASSIC);
        return;
      }
      this.setCurrentPopup(MODALS.AFFILIATIONS);
      this.setCurrentPopupOptions({ allowClose: true });
    },
    onInfoClick() {
      this.setCurrentSmallPopup(MODALS.SMALL_PUBLIC_PROFILE_INFO);
    },
  },
  mounted() {
    this.loaderAdd();
    this.getUserAffiliations()
      .then(() => this.loaderRemove())
      .catch(() => this.loaderRemove());
  },
};



// WEBPACK FOOTER //
// ./src/components/profile/public-profile-widget/public-profile-widget.js